/**
 * Created by calhosh on 8/16/2024
 */
import React, {forwardRef, useEffect, useState} from 'react';
import {labels} from '../../../util/utils';
import {useDispatch, useSelector} from 'react-redux';
import {useDocumentId, useEngagementId, useUserPreferences} from '../../../util/customHooks';
import env from '../../../util/env';
import RemoteComponent from '../ModuleFederation/RemoteComponent';
import envConfig from '@ey/voltron-config';
import NotificationPlaceholder from '../ModuleFederation/NotificationPlaceholder';
import Utility from '../../../util/utilityfunctions';
import TeamsInfo from '../TeamsUser/TeamsInfo';
import {MotifNav} from '@ey/canvascoreservices';
import {MenuIconOptions} from './NavUtils';
import {getEngagement} from '../../../actions/Engagement/engagementactions';
import {getBookmarkAction} from '../../../actions/Task/getBookmarkActions';
import {documentTypes, EngagementStatus, independenceStatus, serviceURL} from '../../../util/uiconstants';
import {raiseJSValidationError} from '../../../actions/erroractions';
import {getQuickLinks} from '../../../actions/Engagement/quicklinksactions';
import {getConfigurations} from '../../../actions/Configuration/configurationactions';
import {getTaskDocumentByDocumentId} from '../../../selectors/Ares/selectors';
import {getIsAutomationHubEnabled} from '../../../reducers/Configurations/configurationsreducer';
import MotifMenuOptions from '../Nav/MotifMenuOptions';
import Label from '@ey/motif-react-wrapper/Label';
import ReactSelect from '../../Common/SelectDropdown/SelectDropdown';
import styled from 'styled-components';
import AIChatbot from '../ModuleFederation/AIChatbot';
import {setAIChatBotIntegrationParameters} from '../../../actions/AIChatbot/AIChatbotActions';

export default function TopBarNav() {
	const searchVariant = {
		control: 'select',
		options: ['expansible', 'overlap', 'fixed']
	};
	const [personData, setPersonData] = useState(undefined);
	const [baseCanvasUrl, setBaseCanvasUrl] = useState('');
	const mode = Utility.getTheme();
	const engagementId = useEngagementId();
	const documentId = useDocumentId();
	const engagement = useSelector((store) => store.engagement);
	const internalUser = useSelector((store) => store.internalUser);
	const configurations = useSelector((store) => store.configurations);
	const quickLink = useSelector((store) => store.quickLink);
	const offlinePrep = useSelector((store) => store.offlinePrep);
	const formData = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));
	const isProfileComplete = engagement?.isProfileComplete;
	const user = useUserPreferences();
	const dashboardDomain = env.getURL('hercules_web');
	const isAutomationHubEnabled = useSelector((store) => getIsAutomationHubEnabled(store));
	const zeusUrl = env.getURL('Zeus_web');
	const engagementMetaData = useSelector((store) => store.engagementMetaData);
	const [defaultSelectedEngagement, setDefaultSelectedEngagement] = useState(undefined);
	const [apiCallsComplete, setApiCallsComplete] = useState(false);
	const [iconOptions, setIconOptions] = useState([]);
	const [hideEverything, setHideEverything] = useState(true);
	const [engagementDropdownOptions, setEngagementDropdownOptions] = useState([]);
	const [gateWayOptionsOpen, setGateWayOptionsOpen] = useState(false);
	const [selectedIcon, setSelectedIcon] = useState(undefined);
	const [showAIChatbot, setShowAIChatbot] = useState(false);
	const [showChatbotIcon, setShowChatbotIcon] = useState(false);

	const isEngagementAccessible =
		(internalUser?.independenceInformation?.isEngagementAccessible || user?.isGuestUser) &&
		!user?.permissions?.hasIndependenceOnlyRole;

	const dispatch = useDispatch();

	const disableEngagementSelector = () => {
		if (engagement && !isProfileComplete) {
			return true;
		} else if (internalUser && internalUser.independenceInformation) {
			/*if looking at my independence show engagement name but not dropdown*/
			return !isEngagementAccessible;
		} else if (user && user.id && !user.isGuestUser) {
			return true;
		} else {
			return true;
		}
	};

	const engagementIsLoading = disableEngagementSelector === true ? false : _.isEmpty(engagement);

	const engagementOptionLabel = ({title, clientname, engdesc, engUrl}) => (
		<a href={engUrl}>
			<section title={title} className="selectOption">
				<section className="selectText">{clientname}</section>
				<section className="engName">{engdesc}</section>
			</section>
		</a>
	);

	const engagementSelectorRender = () => {
		if (!engagementMetaData || engagementMetaData.length === 0 || hideEverything) {
			return (
				<section title={engagement ? engagement.engagementDescription : ''} className="EYEngagementDefault">
					{engagement ? engagement.engagementDescription : ''}
				</section>
			);
		} else {
			return (
				<section className={'EYEngagementDropdown ' + (engagementMetaData ? '' : 'hide')}>
					<StyledEngagementSelect
						className="EYEngagementDropdownSelect"
						placeholder="Select Engagement"
						id="RelatedEngagements"
						noOptionsMessage={() => labels.noResultsFoundLabel}
						isClearable={false}
						options={engagementDropdownOptions}
						value={defaultSelectedEngagement}
						defaultValue={defaultSelectedEngagement}
						formatOptionLabel={engagementOptionLabel}
					/>
				</section>
			);
		}
	};

	useEffect(() => {
		if (engagement && engagement.engagementDescription) {
			document.title = `${engagement.engagementDescription}`;
		}

		let iconOptions = [];
		if (
			apiCallsComplete &&
			engagement?.engagementId &&
			quickLink?.engagementId &&
			configurations?.features &&
			!hideEverything
		) {
			iconOptions = MenuIconOptions({
				engagement: engagement,
				configurations: configurations,
				formData: formData,
				engagements: engagementMetaData?.engagementmetadatadetails,
				displayLanguage: user?.displayLanguage,
				isAutomationHubEnabled: isAutomationHubEnabled,
				gateWayOptionsOpen: gateWayOptionsOpen,
				setGateWayOptionsOpen: setGateWayOptionsOpen,
				selectedIcon: selectedIcon,
				setSelectedIcon: setSelectedIcon,
				quickLinks: quickLink
			});
		}
		setIconOptions(iconOptions);
		setShowChatbotIcon(configurations.features?.isOrchestratorEnabled);
	}, [engagement, configurations, quickLink, apiCallsComplete, engagementMetaData, selectedIcon]);

	const teamsAvatarRender = () => {
		return <TeamsInfo personData={personData} personCardInteraction={'none'} theme={mode} key={'userAvatar'} />;
	};

	const handleSettingsClick = () => {
		window.open(zeusUrl + `/usersettings?referrer=${new URL(window.location.href)}`, '_self');
	};

	const notificationRender = () => {
		return (
			<>
				{configurations && configurations.features && configurations.features.enableNotifications ? (
					<div className="notifications-icon-wrapper">
						<RemoteComponent
							key="notifications"
							id="notifications"
							adConfig={envConfig.ad}
							engagementId={engagement.engagementId}
							darkHeader
							showDummyTriggerButton={false}
							displayLanguage={user?.displayLanguage}
							darkMode={mode}
							newBaseFontSize={true}
							numberFormat={user?.numberFormat}
							liveNotificationDelayInSeconds={configurations.features?.liveNotificationDelayInSeconds}
							loadingFallback={
								<NotificationPlaceholder
									notificationMessage={labels.notificationUpbutSomeLoadingErrorMessage}
									mode={mode}
								/>
							}
							errorFallback={
								<NotificationPlaceholder notificationMessage={labels.notificationDownErrorMessage} mode={mode} />
							}
						/>
						<NotificationPlaceholder
							notificationMessage={labels.notificationUpbutSomeLoadingErrorMessage}
							mode={mode}
						/>
					</div>
				) : (
					<></>
				)}
			</>
		);
	};

	const getBookMarks = () => {
		if (engagement && engagement.engagementId) {
			dispatch(
				getBookmarkAction(
					env.getBaseURL(serviceURL, engagement.engagementId) + 'Tasks?bookmark=true',
					env.getBaseURL(serviceURL, engagement.engagementId),
					engagement.workspaceId
				)
			);
		}
	};

	const getEngagementInformation = () => {
		if (!engagement.engagementId) {
			return dispatch(getEngagement(engagementId, isEngagementAccessible)).catch((result) => {
				if (result && result.response && result.response.status === 403) {
					dispatch(raiseJSValidationError(labels.invalidEngagementId));
				}
			});
		}
	};

	const getEngagementQuickLinks = () => {
		return dispatch(getQuickLinks(env.getBaseURL(serviceURL, Number(engagementId)) + 'QuickLinks'))
			.then(() => {
				let curl = Utility.getCanvasBaseUrl(engagement, user?.displayLanguage);
				setBaseCanvasUrl(curl);
			})
			.catch((result) => {
				if (result && result.response && result.response.status === 403) {
					dispatch(raiseJSValidationError(labels.invalidEngagementId));
				}
			});
	};

	const getConfigurationFeatures = () => {
		let configurationUrl = env.getBaseURL(serviceURL) + 'FeatureConfigurations';
		return dispatch(getConfigurations(configurationUrl)).then(() => {});
	};

	useEffect(() => {
		let result = [];
		if (engagementMetaData && engagementMetaData?.engagementmetadatadetails?.length > 0 && !defaultSelectedEngagement) {
			engagementMetaData.engagementmetadatadetails.map((eng) => {
				const status = eng.engagementstatusid,
					indstatus = eng.independencestatusid;
				if (
					status === EngagementStatus.Active ||
					status === EngagementStatus.Restored ||
					status === EngagementStatus.MarkedForDeletion ||
					status === EngagementStatus.CanvasExternalAccessPortalV2
				) {
					if (
						indstatus === independenceStatus.NOMATTERSIDENTIFIED ||
						indstatus === independenceStatus.MATTERRESOLVEDGRANTEDACCESS ||
						indstatus === independenceStatus.NOTAPPLICABLE
					) {
						const displayedEngagement = {
							value: eng.engagementid,
							label: eng.engagementdescription + ' ' + eng.clientname,
							title: eng.engagementdescription + ' ' + eng.clientname,
							clientname: eng.clientname,
							engdesc: eng.engagementdescription,
							engUrl:
								(dashboardDomain === undefined ? window.location.origin : dashboardDomain) +
								'?engagementid=' +
								eng.engagementid
						};
						if (engagement?.engagementId === Number(eng.engagementid)) {
							setDefaultSelectedEngagement([displayedEngagement]);
						} else {
							result.push(displayedEngagement);
						}
					}
				}
			});
			setEngagementDropdownOptions(result);
		}
	}, [engagementMetaData]);

	useEffect(() => {
		if (engagement?.engagementId && !apiCallsComplete) {
			setHideEverything(false);
			let promiseArray = [/*getEngagementMetaDataCall(),*/ getEngagementInformation()];
			if (quickLink && quickLink.length === 0) {
				promiseArray.push(getEngagementQuickLinks());
			}
			if (!configurations.features) {
				promiseArray.push(getConfigurationFeatures());
			}
			Promise.allSettled(promiseArray).then(() => {
				setApiCallsComplete(true);
			});
		}
	}, [internalUser, engagement]);

	useEffect(() => {
		if (formData && formData.id) {
			if (
				formData.documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL ||
				(formData.documentTypeId === documentTypes.PROFILEV2 && engagement?.isProfileComplete === false)
			) {
				setHideEverything(true);
			} else {
				setHideEverything(false);
			}

			const payload = {
				pageDetails: {
					pageUrl: window.location.href,
					knowledgeTaskId: 0,
					knowledgeFormId: formData.knowledgeFormId
				}
			};
			dispatch(setAIChatBotIntegrationParameters(payload));
		}
	}, [formData]);

	useEffect(() => {
		if (user) {
			setPersonData({
				person: {
					firstName: user.firstName,
					lastName: user.lastName,
					emailAddress: user.emailAddress,
					viewType: 'avatar'
				}
			});
		}
	}, [user]);

	useEffect(() => {
		const payload = {
			pageDetails: {
				pageUrl: window.location.href,
				knowledgeTaskId: 0,
				knowledgeFormId: 0
			}
		};
		dispatch(setAIChatBotIntegrationParameters(payload));
	}, []);

	return (
		<StyledMotifNavWrapper className="StyledMotifNavWrapper motif-no-padding">
			<MotifNav
				key="motifNav"
				applicationName={labels.canvas}
				applicationNameRedirectUrl={zeusUrl}
				disableLogo={false}
				loading={engagementIsLoading}
				showIconLinks={!hideEverything}
				topNavLinks={iconOptions}
				copyrightMessage={labels.copyrightMessage}
				showMoreMenuOptions={!hideEverything}
				showSelectorDropdown
				selectorDropdown={engagementSelectorRender}
				showNotifications={
					!hideEverything && configurations && configurations.features && configurations.features.enableNotifications
				}
				notifications={!hideEverything && notificationRender}
				showSettings={false}
				showSearchBox={false}
				settingsOnClick={handleSettingsClick}
				showAvatar
				teamsAvatar={teamsAvatarRender}
				showAIChatbot={showChatbotIcon}
				aiChatbotOnclick={() => {
					setShowAIChatbot(!showAIChatbot);
				}}
				chatbotTitle={labels.aiChatbot}
			>
				<MotifMenuOptions
					key={'motifMenuOptions'}
					quickLinks={quickLink}
					baseCanvasUrl={baseCanvasUrl}
					isOfflineMode={offlinePrep === true}
					getBookmarkAction={getBookMarks}
					engagementId={engagement.engagementId}
					engagementDescription={engagement.engagementDescription}
					gaRoleTypeId={engagement.gaRoleTypeId}
					featureConfigurations={configurations}
					engagement={engagement}
				/>
			</MotifNav>
			{showAIChatbot && (
				<StyledChatBoxWrapper className={'chatbot-wrapper'}>
					<AIChatbot setShow={setShowAIChatbot} show={showAIChatbot} />
				</StyledChatBoxWrapper>
			)}
		</StyledMotifNavWrapper>
	);
}

TopBarNav.displayName = 'TopBarNav';

const StyledMotifNavWrapper = styled.section`
	.motif-dropdown {
		&.GateWayOptionsDropdown {
			.motif-dropdown-menu {
				gap: var(--spacing-small);
				.ChildSection {
					&:hover {
						background-color: var(--neutrals-50);
						cursor: pointer;
					}
					a {
						color: var(--neutrals-900);
						font-size: var(--px-16);
						font-weight: 300;
						line-height: var(--px-24);
						width: 100%;
						padding: var(--spacing-medium-small) var(--spacing-medium-large);
						&:hover,
						&:focus,
						&:active,
						& {
							color: var(--neutrals-900);
							text-decoration: none;
							border: 0;
						}
						.motif-icon {
							display: inline-flex;
							svg {
								width: 1.2rem;
								height: 1.2rem;
								margin-top: 0 !important;
							}
						}
						.SpanLableTxt {
							display: inline-flex;
							align-items: center;
							font-size: var(--px-14);
							font-weight: 300;
							color: var(--neutrals-900);
						}
					}
				}
			}
		}
	}
`;

const StyledChatBoxWrapper = styled.section``;

const StyledEngagementSelect = styled(ReactSelect)`
	z-index: 999;
`;
